import React from "react";

const Packaging = () => {
  return (
    <div className="m-[50px] text-center font-medium text-[20px]">
      Packaging Indices are coming soon!
    </div>
  );
};

export default Packaging;
